export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14170.edc0af9f.jpg";